import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../reducers/common.reducer";
import { getGameTypeService } from '../services/gametype.service';

const useGameTypeData = () => {
    const [GameTypeData, setGameTypeData] = useState(null);

    const dispatch = useDispatch();

    async function getGameTypeData (signal) {
            
        try {
            dispatch(setIsLoading(true))
            let result = await getGameTypeService(signal);
            if(result.data) {
            setGameTypeData(result.data)
            }
        }
        catch (error) {
            dispatch(
                setToastMessage({
                message: error?.response?.data?.message || error?.message,
                type: "error",
                })
            );
        }
        finally {
            dispatch(setIsLoading(false))
        }
    }

    useEffect(() => {
            
        const controller = new AbortController();
        const signal = controller.signal;
        getGameTypeData(signal);

        return () => {
            controller.abort();
        }
    }, []);


    return [GameTypeData, setGameTypeData]
}

export default useGameTypeData